import { cilBolt, cilChartLine, cilBaseball } from '@coreui/icons'

// One entry per Pulse list. `key` is the type the getTimelineData endpoint takes, `settingKey`
// the threshold field that decides what appears in it, and `stat` the scorecard column it
// compares against (also what the list sorts on by default).
export const PULSE_TYPES = [
  {
    key: 'fantasy',
    label: 'Fantasy',
    settingKey: 'fantasy_points',
    stat: 'fantasy_points',
    statLabel: 'Fantasy Points',
    unit: 'fantasy points',
    tagKey: 'fantasy_tag',
    icon: cilBolt,
    tone: 'primary',
  },
  {
    key: 'batting',
    label: 'Batting',
    settingKey: 'rs_per_inning',
    stat: 'rs',
    statLabel: 'Runs',
    unit: 'runs',
    tagKey: 'batting_tag',
    icon: cilChartLine,
    tone: 'success',
  },
  {
    key: 'bowling',
    label: 'Bowling',
    settingKey: 'wks_per_inning',
    stat: 'wks',
    statLabel: 'Wickets',
    unit: 'wickets',
    tagKey: 'bowling_tag',
    icon: cilBaseball,
    tone: 'info',
  },
]
